<button
  type="button"
  class="ut-btn ut-btn--secondary ut-btn--sm subscribe"
  [class.is-on]="subscribed"
  [class.anim-on]="state.animation() === 'on'"
  [attr.aria-label]="label"
  [attr.aria-busy]="state.busy()"
  [class.hover-locked]="state.hoverLocked()"
  (mouseleave)="state.unlockHover()"
  (click)="toggle()">
  <span class="action__slot">
    <span class="action__idle" [class.is-shown]="!subscribed && !state.loading()">
      <span class="material-icons action__icon" aria-hidden="true">notifications_none</span>
      Subscribe
    </span>
    <span class="action__done" [class.is-shown]="subscribed && !state.loading()">
      <span class="action__rest">
        <svg class="subscribe__check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>
        Subscribed
      </span>
      <span class="action__hover">
        <span class="material-icons action__icon" aria-hidden="true">notifications_off</span>
        Unsubscribe
      </span>
    </span>
    <span class="action__loading" [class.is-shown]="state.loading()" aria-hidden="true">
      <span class="action__dots"><i></i><i></i><i></i></span>
    </span>
  </span>
</button>
<span class="sr-only" aria-live="polite">{{ state.announcement() }}</span>
